export default {
  "APP_INV_CNFG_UPDT": "APP_INV_CNFG_UPDT",
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW"
}